// extracted by mini-css-extract-plugin
export var active = "_q5-1";
export var circle = "_q5-0";
export var completed = "_q5-2";
export var connector = "_q5-4";
export var connectorCompleted = "_q5-7";
export var connectorSpacer = "_q5-5";
export var iconStrokeOverride = "_q5-8";
export var labelContainer = "_q5-6";
export var pending = "_q5-3";